export function test(){
    var res = require('./res.json');
    return res;
}
